import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import Analytics from './services/analytics';

// Pages
import HomePage from './pages/HomePage';
import FeaturesPage from './pages/FeaturesPage';
import PricingPage from './pages/PricingPage';
import IntegrationsPage from './pages/IntegrationsPage';
import TermsPage from './pages/TermsPage';
import PrivacyPage from './pages/PrivacyPage';
import NotFoundPage from './pages/NotFoundPage';
import FractalGraphPage from './pages/FractalGraphPage';

// Layout
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';

// Analytics route change listener
function RouteChangeTracker() {
  const location = useLocation();
  
  useEffect(() => {
    // Extract page name from path
    const pageName = location.pathname === '/' ? 'Home' : 
      location.pathname.charAt(1).toUpperCase() + location.pathname.slice(2).replace(/\//, ' ');
    
    // Track page view
    Analytics.trackPageView(pageName);
  }, [location]);

  return null;
}

function App() {
  return (
    <Router>
      <div className="min-h-screen flex flex-col">
        <Header />
        <RouteChangeTracker />
        <AnimatePresence mode="wait">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/features" element={<FeaturesPage />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/integrations" element={<IntegrationsPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/fractal" element={<FractalGraphPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </AnimatePresence>
        <Footer />
      </div>
    </Router>
  );
}

export default App;